import { Link } from 'react-router-dom';
import { featuredManga } from '@/mocks/manga';

export default function FeaturedGrid() {
  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">
              热门精选
            </span>
            <h2 className="mt-2 text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              本周必读推荐
            </h2>
          </div>
          <p className="mt-4 md:mt-0 text-sm text-foreground-600 max-w-md leading-relaxed">
            精选最受读者欢迎的韩漫作品，每一部都经过读者口碑验证，不容错过的精彩故事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredManga.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className={`group block rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 ${
                index === 1 ? 'bg-primary-900 text-background-50' : 'bg-background-100'
              }`}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium mb-3 ${
                  index === 1
                    ? 'bg-accent-500/20 text-accent-400'
                    : 'bg-accent-100 text-accent-800'
                }`}>
                  {manga.genres[0]}
                </span>
                <h3 className={`text-lg font-bold mb-2 line-clamp-2 ${
                  index === 1 ? 'text-background-50' : 'text-foreground-900'
                }`}>
                  {manga.title}
                </h3>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`ri-star-fill text-sm ${
                        index === 1 ? 'text-accent-400' : 'text-accent-500'
                      }`}></i>
                    </div>
                    <span className={`text-sm font-semibold ${
                      index === 1 ? 'text-background-50' : 'text-foreground-700'
                    }`}>{manga.rating}</span>
                  </div>
                  <span className={`text-xs ${
                    index === 1 ? 'text-foreground-400' : 'text-foreground-500'
                  }`}>
                    {(manga.viewCount / 10000).toFixed(0)}万阅读
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    manga.status === '连载中'
                      ? 'bg-accent-500/20 text-accent-400'
                      : 'bg-secondary-200 text-secondary-700'
                  }`}>
                    {manga.status}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}